/*
 * This plugin listens for elements with an autoinit-QUEUE class (such as input elements) and then executes an init handler on those
 * elements when they're first accessed. This works for elements that are added later in the page timeline such as from an Ajax 
 * request.
 * 
 */
(function($, obj) {
	if ( arguments.length == 1 ) {
		obj = $;
	}
	
	// Stores references to the handler callback methods and the elements
	// being initialized
	var INITIALIZED = {
		handlers:	{},
		elements:	{}
	};
	
	/*
	 * This method executes the init event queue for a given component and element
	 */
	function handleInit(target, component, data) {
		log('onInit:handleInit: ' + component + ' target: ' + target);
		var comp = component.toLowerCase();
		if ( INITIALIZED.handlers[ comp ] && INITIALIZED.handlers[ comp ].length > 0 ) {
			var handlers = INITIALIZED.handlers[ comp ];
			data = data || {};
			
			// If the dataset plugin is active
			if ( $.fn.dataset ) {
				$.extend( data, $(target).dataset() );
			}
			
			for ( var i = 0, il = handlers.length; i < il; i++ ) {
				if ( handlers[i] !== null ) {
					var settings = handlers[i][0];
					if ( handlers[i][1].call(target, settings, { type: comp, target: target }, $.extend(settings.data, data) ) === false ) {
						break;
					}
				}
			}
			// Trigger a jquery custom event
			$( ( target && target.nodeType && target.nodeType == 1 ) ? target : document )
				.trigger('autoinit' + comp, [ { type: component, target: target }, data ] );
		}
	}
	
	/*
	 * This method binds the init callback methods to specific init event queues
	 * where the queue name is matched to the css class autoinit-queue-name => queueName
	 */
	function addHandleInit(component, callback, data) {
		var settings = {
			component:	'',
			handler:	null,
			data:		null
		};
		if ( arguments.length == 1 ) {
			settings = $.extend(settings, arguments[0]);
		} else if ( arguments.length >= 2 ) {
			settings.component	= component;
			settings.handler	= callback;
			settings.data		= data;
		}
		
		var components = settings.component.split(/\s+/);
		for (var i = 0; i < components.length; i++ ) {
			settings.component		= components[i];
			settings.componentClass	= this.componentCssClass( settings.component );
			
			var component = settings.component.toLowerCase();
			if ( !INITIALIZED.handlers[ component ] ) {
				INITIALIZED.handlers[ component ] = [];
				INITIALIZED.elements[ component ] = [];
			}
			INITIALIZED.handlers[ component ].push( [settings, function(settings, evt, data) {
				// Keep a reference to our initialized components
				INITIALIZED.elements[ component ].push( evt.target );
				INITIALIZED.elements[ component ] = $.unique( INITIALIZED.elements[ component ] );
				// Execute the callback
				return settings.handler.call(evt.target, evt, data);
			}]);
		}
	}
	
	/*
	 * This maps some utility methods to the Origin object
	 */
	$.extend(obj, {
		componentCssClass: function(klass) {
			return klass.replace(/([a-z])([A-Z])/g,  '$1-$2')
						.replace(/([a-z])([0-9])/gi, '$1-$2')
						.replace(/([0-9])([a-z])/g,  '$1-$2')
						.toLowerCase();
		},
		
		onInit: addHandleInit,
		
		doInit: function(component, data) {
			$('.autoinit-' + this.componentCssClass( component ) ).doInit(component, data);
		}
	});
	
	/*
	 * Utility method for manually triggering an init event on an element
	 */
	$.fn.doInit = function(component, data) {
		return this.each(function() {
			// handleInit will extract any additional data- arguments
			handleInit( this, component, data );
		});
	};
	
	// Handle capturing focus events in non-ie browsers (virtualizes a focusin event)
	if ( document.addEventListener ) {
		// Capture the focus event in the capture phase
		document.addEventListener('focus', function(evt) {
			if ( $(evt.target).is(':input,form') && !$(evt.target).data('autoinitialized') ) {
			    $(document).trigger('autoinit_focusin', [evt.target]);
			}
		}, true);
	}
	
	/*
	 * This is the 'main' event handling for the core of this plugin.
	 */
	$(document).bind('autoinit_focusin', function(evt, _target) {
		var target = ( _target ? _target : evt.target );
		
		// This throttles our events (by making sure that autoinitilized is false
		if ( !$( target ).is(':input,form') || $( target ).data('autoinitialized') ) {
			return;
		}
		
		// Construct a group of elements (target, parents) and walk
		// through the elements looking for the first component-* class
		$([])
			.add( target )
			.add( $( target ).parents() )
			.filter(':input,form')
			.each(function() {
				// If the component has not been initialized, set a flag on the element
				// and start the initilization
				if ( !$(this).data('autoinitialized') ) {
					$(this).data('autoinitialized', true);
					var dataset = $(this).dataset();
					var components = this.className.split(/\s+/);
					for ( var i = 0, il = components.length; i < il; i++ ) {
						// Iterate through the classes and look for one that starts with autoinit-*
						// when it's matched, hand off the element to the init event queue
						var component = components[i].match( /^autoinit-([^\s]+)$/ );
						if ( component ) {
							component = component[1].replace(/[^a-z0-9]/gi, '').toLowerCase();
							log('onInit:initCaptured: (' + evt.type + ')' + component + ' ' + this.tagName.toLowerCase() + '#' + ( $(this).attr('id') || '' ) + '');
							handleInit( this, component, dataset );
							$(this).removeClass(components[i]);
						}
					}
					$(this).removeData('autoinitialized');
				}
			});
	});
})(jQuery, Origin);